




















































































































































import { defineComponent, ref, onMounted } from '@vue/composition-api';
import sl from '@/serviceLocator';
import { DataTableHeader } from 'vuetify';
import { QuarantineText } from '@oare/types';
import { DateTime } from 'luxon';
import Reautheticate from '@/views/Authentication/Verification/Reautheticate.vue';
import EpigraphyView from '@/views/Texts/EpigraphyView/index.vue';

export default defineComponent({
  name: 'QuarantinedTexts',
  components: {
    Reautheticate,
    EpigraphyView,
  },
  setup() {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const loading = ref(false);

    const listHeaders = ref<DataTableHeader[]>([
      { text: 'Name', value: 'name' },
      { text: 'Quarantined Since', value: 'timestamp' },
    ]);

    const texts = ref<QuarantineText[]>([]);
    const selectedTexts = ref<QuarantineText[]>([]);

    onMounted(async () => {
      try {
        loading.value = true;
        texts.value = await server.getQuarantinedTexts();
        texts.value = texts.value.sort((a, b) =>
          a.text.name && b.text.name
            ? a.text.name.localeCompare(b.text.name)
            : -1
        );
      } catch (err) {
        actions.showErrorSnackbar(
          'Error loading quarantined texts. Please try again.',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    });

    const formatTimestamp = (timestamp: Date) => {
      return DateTime.fromJSDate(new Date(timestamp)).toLocaleString(
        DateTime.DATETIME_MED
      );
    };

    const confirmRestoreDialog = ref(false);
    const restoreLoading = ref(false);

    const restoreTexts = async () => {
      try {
        restoreLoading.value = true;
        const uuidsToRestore = selectedTexts.value.map(text => text.text.uuid);
        await Promise.all(uuidsToRestore.map(uuid => server.restoreText(uuid)));
        texts.value = texts.value.filter(
          text => !uuidsToRestore.includes(text.text.uuid)
        );
        actions.showSnackbar('Successfully restored text(s).');
        selectedTexts.value = [];
      } catch (err) {
        actions.showErrorSnackbar(
          'Error restoring text(s). Please try again.',
          err as Error
        );
      } finally {
        confirmRestoreDialog.value = false;
        restoreLoading.value = false;
      }
    };

    const confirmDeleteDialog = ref(false);
    const deleteLoading = ref(false);

    const deleteTexts = async () => {
      try {
        deleteLoading.value = true;
        const uuidsToDelete = selectedTexts.value.map(text => text.text.uuid);
        await Promise.all(
          uuidsToDelete.map(uuid => server.permanentlyDeleteText(uuid))
        );
        texts.value = texts.value.filter(
          text => !uuidsToDelete.includes(text.text.uuid)
        );
        actions.showSnackbar('Successfully deleted text(s).');
        selectedTexts.value = [];
      } catch (err) {
        actions.showErrorSnackbar(
          'Error deleting text(s). Please try again.',
          err as Error
        );
      } finally {
        confirmDeleteDialog.value = false;
        deleteLoading.value = false;
      }
    };

    const reautheticateDialog = ref(false);

    const setupReauthentication = () => {
      reautheticateDialog.value = true;
    };

    const handleReauthentication = async () => {
      await deleteTexts();
    };

    const selectedTextUuid = ref<string | null>(null);
    const selectedTextDialog = ref(false);

    const setupTextDialog = (textUuid: string) => {
      selectedTextUuid.value = textUuid;
      selectedTextDialog.value = true;
    };

    return {
      loading,
      listHeaders,
      texts,
      selectedTexts,
      formatTimestamp,
      restoreTexts,
      confirmRestoreDialog,
      restoreLoading,
      confirmDeleteDialog,
      deleteLoading,
      deleteTexts,
      reautheticateDialog,
      setupReauthentication,
      handleReauthentication,
      selectedTextUuid,
      selectedTextDialog,
      setupTextDialog,
    };
  },
});
